<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/5SReport/NotificationKPI'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่เริ่มต้น:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reStartDate"
                      name="reStartDate"
                      ref="reStartDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">วันที่สิ้นสุด:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reEndDate"
                      name="reEndDate"
                      ref="reEndDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เขตการขาย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reDepartments'"
                    :name="'reDepartments'"
                    :select2-options="reDepartmentsOptions"
                    multiple
                    v-model="reDepartments"
                  ></select2> -->
                  <treeselect
                    v-model="reDepartments"
                    :multiple="true"
                    :options="reDepartmentsOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAgentCodes'"
                    :name="'reAgentCodes'"
                    :select2-options="reAgentCodesOptions"
                    multiple
                    v-model="reAgentCodes"
                  ></select2> -->
                  <treeselect
                    v-model="reAgentCodes"
                    :multiple="true"
                    :options="reAgentCodesOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="5SByAgentTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="7">
                      ข้อมูล ณ วันที่ {{ reAaDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">ตัวแทนจำหน่าย</th>
                    <th class="all text-center">เขตขาย</th>
                    <th class="all text-center">จำนวนวันในการไม่กรอก KPIs</th>
                    <th class="all text-center">แจ้งเตือนครั้งล่าสุด</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      reAaDateReq: null,
      reStartDate: null,
      reEndDate: null,
      reDepartments: [],
      reAgentCodes: [],
      reIsInitial: true,
      reDepartmentsOptions: [],
      // reDepartmentsOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเขตการขาย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchDepartment",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAgentCodesOptions: [],
      // reAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_5S",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.reStartDate = null;
      self.reEndDate = null;
      self.reDepartments = [];
      self.reAgentCodes = [];

      $("#reStartDate")
        .val("")
        .trigger("change");

      $("#reEndDate")
        .val("")
        .trigger("change");

      $("#reDepartments")
        .val("")
        .trigger("change");

      $("#reAgentCodes")
        .val("")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      let self = this;

      e.preventDefault();
      var table = $("#5SByAgentTable").DataTable();
      table.draw();
    },
    LoadreDepartmentsOptions: function(e) {
      var self = this;
      axios
        .get("/Api/MasterSalesArea/FindOptions", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reDepartmentsOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreAgentCodesOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_5S", {
          province_id: [],
          department: [],
          AgentCodes: [],
          page: 1,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reAgentCodesOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
  },
  async mounted() {
    let self = this;

    self.LoadreDepartmentsOptions();
    self.LoadreAgentCodesOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.reStartDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reStartDate = moment().set("date",1);
    $(self.$refs.reStartDate)
      .datepicker(
        "update",
        !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reEndDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.reEndDate)
      .datepicker(
        "update",
        !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#5SByAgentTable");
    table.DataTable({
      autoWidth: true,
      scrollY: "100%",
      scrollX: true,
      responsive: true,
      processing: true,
      serverSide: true,
      searchDelay: 500,
      ajax: {
        url: "/Api/Report/NotificationKPI",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        beforeSend: function(request) {
          request.setRequestHeader(
            "Authorization",
            "Bearer " + self.$root.user.access_token
          );
        },
        data: function(d) {
          let jsonSearch = {
            StartDate:
              self.reStartDate != null
                ? self.reStartDate.format("DD/MM/YYYY")
                : self.reStartDate,
            EndDate:
              self.reEndDate != null
                ? self.reEndDate.format("DD/MM/YYYY")
                : self.reEndDate,
            SalesArea: self.reDepartments,
            AgentCodes: self.reAgentCodes,
            IsInitial: self.reIsInitial,
          };
          return JSON.stringify($.extend(d, jsonSearch));
        },
      },
      // DOM Layout settings
      dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

      lengthMenu: [30, 50, 100],

      pageLength: 30,

      language: {
        lengthMenu: "Display _MENU_",
      },
      // Order settings
      order: [[2, "desc"]],
      columns: [
        {
          data: "agentCode",
          className: "text-center",
          sortable: false,
          render: function(data, type, full, meta) {
            var t = table.DataTable();
            var page = t.page.info().start + 1;
            return page + meta.row;
          },
        },
        { data: "agentName", className: "text-center" },
        { data: "departments", className: "text-center" },
        { data: "notificationNo", className: "text-center" },
        { data: "createDateString", className: "text-center" },
      ],
      drawCallback: function (settings) {
          self.reIsInitial = false;
          self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
        },
    })
    .on("error.dt", function ( e, settings, techNote, message ) {
      DatatableWarning.alert(techNote);
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/NotificationKPI.vue